exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-grid[data-v-9e0181f8] {\n    display: inline-grid;\n    grid-template-columns: repeat(11, auto);\n    gap: 5px;\n    justify-content: start;\n}\n.color-button[data-v-9e0181f8] {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    border: 1px solid #ccc;\n    cursor: pointer;\n    padding: 0;\n}\n", ""]);

// exports
